




















































import Navbar from "../components/Navbar.vue";
import Sidebar from "../components/Sidebar.vue";
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";

const Subscriptions = namespace("subscriptions");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const utc = require("dayjs/plugin/utc");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    navbar: Navbar,
    sidebar: Sidebar,
  },
})
export default class Home extends Vue {
  @Subscriptions.Getter("isQuotaExpired") isQuotaExpired: boolean;
  @Subscriptions.Getter("getQuotaExpirationDate") quotaExpirationDate!: string;
  @Subscriptions.Getter("getQuotaStartDate") quotaStartDate!: string;
  @Subscriptions.Getter("isSandboxActive") isSandboxActive!: boolean;
  @Subscriptions.Action("getQuotaInformation")
  getQuotaInformation!: () => Promise<{}>;

  daysTillExpiration = 0;

  async mounted() {
    await this.getQuotaInformation();
    this.setTimeToExpiration();
  }

  setTimeToExpiration() {
    const endDate = dayjs(this.quotaExpirationDate);
    this.daysTillExpiration = endDate.diff(Date.now(), "day");
  }
}
